import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { getStatusTokens } from "styles/tokens/status";

/** early_bird → Early Bird (keeps raw `status` for color tokens) */
function humanizeStatusLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  return String(value)
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

const StatusBadge = ({ status, label, size = "sm" }) => {
  const tokens = getStatusTokens(status);
  // v2: chip radius and the v2 typeface; colours stay the shared status tokens.
  const v2 = useTheme()?.pearlUi === "v2";
  const displayLabel = label ?? humanizeStatusLabel(status) ?? "Draft";

  const fontSize = size === "xs" ? "0.6875rem" : "0.75rem";
  const py = size === "xs" ? 0.35 : 0.5;
  const px = size === "xs" ? 1.25 : 1.5;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px,
        py,
        bgcolor: tokens.background,
        color: tokens.text,
        borderRadius: v2 ? "10px" : 999,
        fontSize,
        fontWeight: 600,
        fontFamily: v2 ? "inherit" : '"Hanken Grotesk", "Inter", "Helvetica", "Arial", sans-serif',
        letterSpacing: "0.02em",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: tokens.dot,
          flexShrink: 0,
        }}
      />
      {displayLabel}
    </Box>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm"]),
};

export default StatusBadge;
